export function domReady(fn) {
    function onReady(event) {
        document.removeEventListener("DOMContentLoaded", onReady);
        fn(event);
    }
    document.addEventListener && document.addEventListener("DOMContentLoaded", onReady);
}
